import { render, staticRenderFns } from "./DailyRecipe.vue?vue&type=template&id=6948cf9e&scoped=true"
import script from "./DailyRecipe.vue?vue&type=script&lang=js"
export * from "./DailyRecipe.vue?vue&type=script&lang=js"
import style0 from "./DailyRecipe.vue?vue&type=style&index=0&id=6948cf9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6948cf9e",
  null
  
)

export default component.exports